import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface PermissionRouteProps {
  permission?: string;
  anyOf?: string[];
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ permission, anyOf = [] }) => {
  const { hasPermission } = useAuthStore();
  const allowed = permission ? hasPermission(permission) : anyOf.some(hasPermission);
  return allowed ? <Outlet /> : <Navigate to="/dashboard" replace />;
};

export default PermissionRoute;
